import React from "react";
import { useNavigate } from "react-router-dom";
import CreateUserForm from "../components/Admin/CreateUserForm";
import UsersList from "../components/Admin/UsersList";
import { useUser } from "../context/UserContext";
import CardAdmin from '../components/UI/CardAdmin';
import Positions from '../components/Admin/Positions';
import Tabs from '../components/UI/Tabs';
import LogsPage from '../components/Admin/LogsPage';
import ShiftScheduleForm from '../components/Admin/ShiftScheduleForm';
import WorkShiftLogs from '../components/Admin/WorkShiftLogs';

const AdminDashboard = () => {
    const { hasAnyPermission, hasPermission, user } = useUser();
	const canPositions = hasAnyPermission("positions", ["view", "create", "edit", "delete"]);
	const canUsers = hasPermission("users", "create");
	const userList = hasPermission("users", "view");
	const canEvents = hasPermission("events", "view");
	const canLogs = hasPermission("logs", "view");
	const canShifts = hasPermission("shifts", "view");
	const canWorkShiftLogs = hasPermission("shift_logs", "view");
    const navigate = useNavigate();

	const tabs = [];
	if (!canEvents && !canUsers && !canPositions && !userList && !canShifts) {
		return <div className="text-red-500 text-center text-2xl">У вас нет прав на табеле</div>;
	}

	if (canWorkShiftLogs) {
		tabs.push(
			{
				label: 'Табель',
				content: (
					<CardAdmin>
						<h2 className="text-xl font-semibold mb-8">Логи смен</h2>
						<WorkShiftLogs />
					</CardAdmin>
				)
			}
		)
	}


	if (userList) {
		tabs.push({
			label: 'Список пользователей',
			content: (
				<CardAdmin>
					<h2 className="text-xl font-semibold mb-8">
						Список пользователей
					</h2>
					<UsersList />
				</CardAdmin>
			)
		})
	}

	if (canPositions) {
		tabs.push({
			label: 'Должности',
			content: (
					<CardAdmin>
						<h2 className="text-xl font-semibold mb-8">
							Должности
						</h2>
						<Positions />
					</CardAdmin>
				)
			}
		)
	}

	if (canUsers) {
		tabs.push({
			label: 'Создание пользователя',
			content: (
				<CardAdmin>
					<h2 className="text-xl font-semibold mb-8">
						Создание пользователя
					</h2>
					<CreateUserForm />
				</CardAdmin>
			)
		})
	}

	if (canShifts) {
		tabs.push({
			label: 'Управление сменами',
			content: (
				<CardAdmin>
					<h2 className="text-xl font-semibold mb-8">
						Управление сменами
					</h2>
					<ShiftScheduleForm />
				</CardAdmin>
			)
		})
	}

	if (canLogs) {
		tabs.push({
			label: 'Логи',
			content: (
				<CardAdmin>
					<h2 className="text-xl font-semibold mb-8">
						Логи
					</h2>
					<LogsPage />
				</CardAdmin>
			)
		})
	}


    return (
        <div className="min-h-screen bg-[#1E1E1E] p-6 text-[#CCCCCC]">
            <Tabs tabs={tabs} />
        </div>
    );
};

export default AdminDashboard;
